import http, { HEADERS } from "../http";

export function postLogin({ params }) {
  return http.post("/auth/login", params, { headers: HEADERS.AUTH });
}

export function postRegister(params) {
  return http.post("/auth/register", params, { headers: HEADERS.AUTH });
}

export function postSocial(params) {
  return http.post("/auth/social", params, { headers: HEADERS.AUTH });
}

export const requestOtp = (params) => {
  return http.post("/auth/otp/request", params, { headers: HEADERS.JSON });
};

export function refresh(params) {
  return http.post("/auth/refresh", params, { headers: HEADERS.AUTH });
}

export function verifyOtp(params) {
  return http.post("/auth/otp/check", params, { headers: HEADERS.JSON });
}

export function resetPassword(params) {
  return http.put("/auth/password/reset", params);
}

export function storeFcmToken({ params }) {
  return http.post("/auth/fcmtoken/store", params);
}

export function getSession() {
  return http.get("/auth/session");
}

export function revokeSession(params) {
  return http.delete("/auth/session/revoke", params, { headers: HEADERS.AUTH });
}

export function updateStatus({ params }) {
  return http.patch("/auth/status/update", params);
}

export function logout({ params }) {
  return http.delete("/auth/logout", params, { headers: HEADERS.AUTH });
}
